/** Colores unificados Enviado / Recibido (chips, filtros, badges). */
export function getMessageDirectionTheme(dark: boolean) {
  const sent = {
    text: dark ? "#6ee7b7" : "#047857",
    chipBg: dark ? "rgba(52, 211, 153, 0.22)" : "#ecfdf5",
    filterBg: dark ? "rgba(52, 211, 153, 0.22)" : "rgba(16, 185, 129, 0.14)",
    border: dark ? "rgba(52, 211, 153, 0.42)" : "rgba(16, 185, 129, 0.42)",
  };

  const received = {
    text: dark ? "#67e8f9" : "#0e7490",
    chipBg: dark ? "rgba(0, 187, 205, 0.18)" : "rgba(0, 187, 205, 0.12)",
    filterBg: dark ? "rgba(0, 187, 205, 0.18)" : "rgba(0, 187, 205, 0.14)",
    border: dark ? "rgba(0, 187, 205, 0.42)" : "rgba(0, 187, 205, 0.42)",
  };

  return {
    sent: {
      ...sent,
      tone: { icon: sent.text, bg: sent.filterBg, border: sent.border },
    },
    received: {
      ...received,
      tone: { icon: received.text, bg: received.filterBg, border: received.border },
    },
  };
}
